// @ts-nocheck
import React from 'react'
import cx from 'classnames'

import { Loader } from 'components/shared/Loader/Loader'
import { ListItem } from './common/ListItem/ListItem'

import styles from './InfiniteScroll.module.scss'

export const InfiniteScroll = ({
  children,
  className = undefined,
  tagName,
  isPending,
}) => {
  const Element = tagName ?? 'menu'

  return (
    <Element className={cx(styles.list, { [className]: Boolean(className) })}>
      {children}
      {isPending ? (
        <ListItem className={styles.loader}>
          <Loader isInline />
        </ListItem>
      ) : null}
    </Element>
  )
}

InfiniteScroll.Item = ListItem
